@if (!(fieldItem.fieldInfo.fieldNotInForce && !fieldItem.hasValue)) {
  @switch (fieldItem.fieldInfo.fieldTypeFrontId) {
    @case ('text') {
      @if (fieldItem.fieldInfo.sequentialView && isLanding) {
        <field-type-text-sequential
          [field]="fieldItem.fieldInfo"
          [concept]="concept"
          [preSelectItem]="fieldItem.preDefined"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (saveVoiceRecord)="saveVoiceRecord($event)"
          (openRelatedInfo)="openRelatedInfo($event)">
        </field-type-text-sequential>
      }@else if (fieldItem.fieldInfo.multiline) {
        <field-type-text-multiline
          [field]="fieldItem.fieldInfo"
          [concept]="concept"
          [preSelectItem]="fieldItem.preDefined"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (saveVoiceRecord)="saveVoiceRecord($event)"
          (openRelatedInfo)="openRelatedInfo($event)">
        </field-type-text-multiline>
      }@else {
        <field-type-text-simple
          [field]="fieldItem.fieldInfo"
          [concept]="concept"
          [preSelectItem]="fieldItem.preDefined"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)">
        </field-type-text-simple>
      }
    }
    <!-- list | listp | l-fo  normal-->
    @case ('list') {
      @if (fieldItem.fieldInfo.numericalScale) {
        <field-type-list-numerical
          [field]="fieldItem.fieldInfo"
          [preSelectItem]="fieldItem.preDefined"
          [listValues]="fieldItem.fieldInfo.listValues"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)"
          [public]="public">
        </field-type-list-numerical>
      }@else if (fieldItem.fieldInfo.isHighlight) {
        <field-type-list-highlight
          [field]="fieldItem.fieldInfo"
          [preSelectItem]="fieldItem.preDefined"
          [listValues]="fieldItem.fieldInfo.listValues"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)"
          [public]="public">
        </field-type-list-highlight>
      }@else if (fieldItem.fieldInfo.isTypeButton) {
        <field-type-list-button
          [field]="fieldItem.fieldInfo"
          [preSelectItem]="fieldItem.preDefined"
          [listValues]="fieldItem.fieldInfo.listValues"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)"
          [public]="public">
        </field-type-list-button>
      }@else if (isLanding && fieldItem.fieldInfo.sequentialView) {
        <field-type-list-sequential
          [field]="fieldItem.fieldInfo"
          [preSelectItem]="fieldItem.preDefined"
          [listValues]="fieldItem.fieldInfo.listValues"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          [public]="public">
        </field-type-list-sequential>
      }@else if(fieldItem.fieldInfo.multiple) {
        <field-type-list-multiple
          [field]="fieldItem.fieldInfo"
          [preSelectItem]="fieldItem.preDefined"
          [listValues]="fieldItem.fieldInfo.listValues"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)"
          [public]="public">
        </field-type-list-multiple>
      }@else {
        <field-type-list-simple
          [field]="fieldItem.fieldInfo"
          [preSelectItem]="fieldItem.preDefined"
          [listValues]="fieldItem.fieldInfo.listValues"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)"
          [public]="public">
        </field-type-list-simple>
      }
      <!-- @if (isLanding && fieldItem.fieldInfo.poll && fieldItem.fieldInfo.sequentialView) {
        @if (!fieldItem.fieldInfo.multiple && !fieldItem.fieldInfo.numericalScale && !fieldItem.fieldInfo.isHighlight && !fieldItem.fieldInfo.isTypeButton) {
          <sequential-list-simple
            [field]="fieldItem.fieldInfo"
            [preSelectItem]="fieldItem.preDefined"
            [listValues]="fieldItem.fieldInfo.listValues"
            (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
            (openRelatedInfo)="openRelatedInfo($event)"
            [public]="public">
          </sequential-list-simple>
        }
        @if (fieldItem.fieldInfo.multiple && !fieldItem.fieldInfo.numericalScale && !fieldItem.fieldInfo.isHighlight && !fieldItem.fieldInfo.isTypeButton) {
          <sequential-list-multiple
            [field]="fieldItem.fieldInfo"
            [preSelectItem]="fieldItem.preDefined"
            [listValues]="fieldItem.fieldInfo.listValues"
            (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
            (openRelatedInfo)="openRelatedInfo($event)"
            [public]="public">
          </sequential-list-multiple>
        }
        @if (fieldItem.fieldInfo.numericalScale) {
          <sequential-list-numerical
            [field]="fieldItem.fieldInfo"
            [preSelectItem]="fieldItem.preDefined"
            [listValues]="fieldItem.fieldInfo.listValues"
            (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
            (openRelatedInfo)="openRelatedInfo($event)"
            [public]="public">
          </sequential-list-numerical>
        }
        @if (fieldItem.fieldInfo.isHighlight) {
          <sequential-list-highlight
            [field]="fieldItem.fieldInfo"
            [preSelectItem]="fieldItem.preDefined"
            [listValues]="fieldItem.fieldInfo.listValues"
            (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
            (openRelatedInfo)="openRelatedInfo($event)"
            [public]="public">
          </sequential-list-highlight>
        }
      } -->
    }
    <!-- list | listp | l-fo extendida-->
    @case ('list-extended') {
      <field-type-list-extended
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [listValues]="fieldItem.fieldInfo.listValues"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-list-extended>
    }
    <!-- num | money -->
    @case ('num') {
      <field-type-number
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [concept]="concept"
        (itemSelected) = "itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        [decimals]="fieldItem.fieldInfo.decimals"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-number>
    }
    @case ('date') {
      <field-type-date
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [concept]="concept"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (createAlert)="createAlert($event)"
        (openRelatedInfo)="openRelatedInfo($event)"
        [public]="public">
      </field-type-date>
    }
    @case ('file') {
      <field-type-file
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [concept]="concept"
        [conceptListStates]="concept?.listStates"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-file>
    }
    @case ('l-co') {
      <field-type-other
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [concept]="concept"
        [listValues]="fieldItem.fieldInfo.listValues"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (itemSelectedAdditional)="itemSelectedAdditional($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-other>
    }
    @case ('l-sg') {
      <field-type-other
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [concept]="concept"
        [listValues]="fieldItem.fieldInfo.listValues"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (itemSelectedAdditional)="itemSelectedAdditional($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-other>
    }
    @case ('emai') {
      <field-type-email
        [field]="fieldItem.fieldInfo"
        [concept]="concept"
        [preSelectItem]="fieldItem.preDefined"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-email>
    }
    @case ('link') {
      <field-type-link
        [field]="fieldItem.fieldInfo"
        [concept]="concept"
        [preSelectItem]="fieldItem.preDefined"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-link>
    }
    @case ('time') {
      <field-type-time
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-time>
    }
    <!-- formu 1 formp -->
    @case ('formu') {
      @if (!(fieldItem.fieldInfo.fieldTypeId === 'formp' && fieldItem.fieldInfo.isHtml)) {
        <field-type-formu
          [field]="fieldItem.fieldInfo"
          [concept]="concept"
          [evaluatedConcepts]="evaluatedConcepts"
          [evaluatedFields]="fieldItem.evaluatedFields"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)">
        </field-type-formu>
      }
      @if (fieldItem.fieldInfo.fieldTypeId === 'formp' && fieldItem.fieldInfo.isHtml) {
        <field-type-form-rich
          [field]="fieldItem.fieldInfo"
          [concept]="concept"
          [evaluatedConcepts]="evaluatedConcepts"
          [evaluatedFields]="fieldItem.evaluatedFields"
          (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
          (openRelatedInfo)="openRelatedInfo($event)">
        </field-type-form-rich>
      }
    }
    @case ('txchk') {
      <field-type-txchk
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-txchk>
    }
    <!-- templ-->
    @case ('templ') {
      <field-type-template
        [field]="fieldItem.fieldInfo"
        [concept]="concept"
        [preSelectItem]="fieldItem.preDefined"
        [public]="public"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (changeConcept)="changeConcept($event)">
      </field-type-template>
    }
    <!-- pepl-->
    @case ('pepl') {
      <field-type-consult-lists
        [field]="fieldItem.fieldInfo"
        [fieldContainer]="fieldContainer"
        [concept]="concept">
      </field-type-consult-lists>
    }
    <!-- alert -->
    @case ('alert') {
      <field-type-alert
        [field]="fieldItem.fieldInfo"
        [preSelectItem]= "fieldItem.preDefined"
        (itemSelected)= "itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        [concept]="concept"
        (createAlert)="createAlert($event)">
      </field-type-alert>
    }
    <!-- report -->
    @case ('rpt') {
      <field-type-report
        [field]="fieldItem.fieldInfo"
        (launchActionEmit)="launchActionOn($event)">
      </field-type-report>
    }
    @case ('task') {
      <field-type-task
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)">
      </field-type-task>
    }
    @case ('rich') {
      <field-type-rich-text
        [field]="fieldItem.fieldInfo"
        [concept]="concept"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-rich-text>
    }
    @case ('rich-editable') {
      <field-type-rich-text-editable
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        [textDescription]="true"
        [concept]="concept"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (saveVoiceRecord)="saveVoiceRecord($event)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-rich-text-editable>
    }
    @case ('bool') {
      <field-type-bool
        [field]="fieldItem.fieldInfo"
        [preSelectItem]="fieldItem.preDefined"
        (itemSelected)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-bool>
    }
    @case ('user') {
      <field-type-contacts
        [field]="fieldItem.fieldInfo"
        [concept]="concept"
        (sendContacts)="itemSelected($event, fieldItem.fieldInfo.fieldTypeId)"
        (openRelatedInfo)="openRelatedInfo($event)">
      </field-type-contacts>
    }
  }
}
